module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "height": "200px",
      "width": "100%",
      "align-items": "center",
      "justify-content": "center",
      "transform": "scale(0.25)"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/gears_loading_1.svg",
      "alt": "incarcare..."
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "src": "/static/gears_loading_3.svg",
      "alt": "loading..."
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "-50px",
      "margin-left": "-50px"
    },
    attrs: {
      "src": "/static/gears_loading_2.svg",
      "alt": "incarcare..."
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fc989a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 175
// module chunks = 27